import {
  Col,
  Divider,
  Form,
  Input,
  Row,
  Typography,
  Modal as AntModal,
} from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "shared/components";
import { createInviteDiagnostic } from "shared/service/StrmService";

interface ModalDiagnoseProps {
  visible: boolean;
  onCancel: () => void;
  onSend: () => void;
  teamId?: string;
}

const { success, error } = AntModal;
const ModalDiagnose: React.FC<ModalDiagnoseProps> = (props) => {
  const { teamId, onSend, ...modalProps } = props;
  const { t } = useTranslation("radar");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);

  const onFinish = async () => {
    const values: any = form.getFieldsValue(true);
    setLoading(true);
    const request = {
      teamId: teamId,
      ...values,
    };

    const response: any = await createInviteDiagnostic(request);
    if (response)
      success({
        title: t("pages.Diagnostic.modalDiagnoseSuccessSendInviteSuccessTitle"),
        content: t(
          "pages.Diagnostic.modalDiagnoseSuccessSendInviteSuccessContent"
        ),
        icon: "",
        cancelButtonProps: {
          style: {
            display: "none",
          },
        },
        okButtonProps: {
          className: "botao-verde",
          style: { padding: 0 },
        },
        okType: "link",
        onOk() {
          console.log("ok");
        },
      });
    else
      error({
        title: t("pages.Diagnostic.modalDiagnoseSuccessSendInviteFailTitle"),
        content: t(
          "pages.Diagnostic.modalDiagnoseSuccessSendInviteFailContent"
        ),
        icon: "",
        cancelButtonProps: {
          style: {
            display: "none",
          },
        },
        okButtonProps: {
          className: "botao-vermelho",
          style: { padding: 0 },
        },
        okType: "link",
      });
    setLoading(false);
    onSend();
  };

  return (
    <Modal
      {...modalProps}
      showCancelButton={false}
      okText={t("pages.Diagnostic.send")}
      onOk={onFinish}
      okButtonDisabled={loading}
    >
      <div className="modal-diagnose">
        <Typography.Title
          level={5}
          style={{ color: "#fff", textAlign: "start", marginBottom: 0 }}
        >
          {t("pages.Diagnostic.diagnoseModalTitle")}
        </Typography.Title>
        {/* <PageHeader title={t("pages.Diagnostic.diagnoseModalTitle")} /> */}
        <Divider style={{ backgroundColor: "#E0E2E7" }} />
        <Typography.Paragraph style={{ color: "#fff", textAlign: "left" }}>
          {t("pages.Diagnostic.diagnoseDescription")}
        </Typography.Paragraph>
        <Row justify="center">
          <Col xs={20}>
            <Form form={form} onFinish={onFinish} layout="vertical">
              <Form.Item name="name" label={t("pages.Diagnostic.name")}>
                <Input />
              </Form.Item>
              <Form.Item name="userLogin" label={t("pages.Diagnostic.email")}>
                <Input />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default ModalDiagnose;
